import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NotificationsFacade } from "@modules/notifications/domain/+state/notifications.facade";
import { Observable } from "rxjs";
import { NotificationsModel, NotificationState } from "@modules/notifications/domain/entities/notifications.model";
import { NotificationsBoardComponent } from "@modules/notifications/features/notifications-board/notifications-board.component";
import { NotificationsRoutingFacade } from "@modules/notifications/domain/+state/notifications-routing-facade.service";
import { NOTIFICATIONS_PER_PAGE } from "@helpers/constants";

@Component({
	selector: "notifications-list",
	templateUrl: "./notifications-list.component.html",
	styleUrls: ["./notifications-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NotificationsListComponent {
	public notificationIcons$: Observable<NotificationsModel[]> = this.notificationsFacade.getNotificationsIcons$();
	public isLoading$: Observable<boolean> = this.notificationsFacade.getLoadingObservable$();
	public endOfNotificationList$: Observable<boolean> = this.notificationsFacade.isEndOfList$();
	public notificationState = NotificationState;
	public notificationPerPage: number = NOTIFICATIONS_PER_PAGE;

	public constructor(
		private readonly notificationsFacade: NotificationsFacade,
		private readonly notificationsRoutingFacade: NotificationsRoutingFacade,
		private readonly notificationsBoardComponent: NotificationsBoardComponent
	) {}

	public onScrolledToBottom(numberOfMessages: number): void {
		if (numberOfMessages >= NOTIFICATIONS_PER_PAGE) {
			this.notificationsFacade.fetchNextPage();
		}
	}

	public onClickNotification(event): void {
		const eventName = event.event.name;
		this.notificationsFacade.rudderstackTracking("Message List Item Clicked", eventName);
		if (event.event?.target_path) {
			this.notificationsBoardComponent.onCloseClick.emit();
			this.notificationsRoutingFacade.getTarget(event.event.target_path, event.pid);
		}
	}
}
